import React from "react";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import styles from "./index.module.scss";
const SliderC = Slider as any;

interface SlicerCProps {
  values: number;
  setValues: (value: number) => void;
}
export default function SlicerC({ values, setValues }: SlicerCProps) {
  const horizontalLabels: any = {
    min: 1,
    max: 100,
    value: Number(values)?.toFixed(2)
  };

  return (
    <div className={styles.sliderBox}>
      <div className={styles.valueWrap}>
        <span>{horizontalLabels.min}</span>
        <span>{horizontalLabels.max}</span>
      </div>
      <SliderC
        min={1}
        max={100}
        value={values}
        step={1}
        handleLabel={`${values}`}
        orientation="horizontal"
        onChange={setValues}
        className={styles.sliderInput}
        tooltip={false}
      />
    </div>
  );
}
